import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { X, QuestionCircle } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import {
  createItem,
} from '../../../../../../../../../../crud/menu_api/items';
import { getItemThirdPartyPrices, setItemThirdPartyPrice, deleteItemThirdPartyPrice } from '../../../../../../../../../../crud/menu_api/items';
import { GetAllThirdPartyProviders } from '../../../../../../../../../../crud/configuration_api/third_party_providers';
import { getStorageUnitsByLocalId } from '../../../../../../../../../../crud/management_api/storage_units';
import { getUnidadesMedidaOptions,getCategoryOptions } from '../../../functions/functions';
import { IngredientSelection, Option } from '../../../../types';
import './CreateItem.scss';
import MiniLoadingSpinner from '../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import { Item } from '../../../../../../types';
// import ItemCreationModeSelector from './components/ItemCreationModeSelector/ItemCreationModeSelector';
import FormNavigation from './components/FormNavigation/FormNavigation';
import ItemHelpModal from './components/ItemHelpModal/ItemHelpModal';
import BasicInfoSection from './components/BasicInfoSection/BasicInfoSection';
import AdvanceInfoSection from './components/AdvanceInfoSection/AdvanceInfoSection';
import AdditionsInfoSection from './components/AdditionsInfoSection/AdditionsInfoSection';
import { MenuCategoryNode } from '../../../../../../types/menu.types';

interface ModalProps {
  show: boolean;
  handleClose: () => void;
  categoryId?: string | null;
  items: any[];
  setItems: any;
  setData: (data: any[]) => void;
  originalItems: Item[];
  setOriginalItems: (data: Item[]) => void;
  allItems: Item[];
  updateCategoryItems?: (updatedCategory: MenuCategoryNode) => void; // NUEVO
}




const CreateItem: React.FC<ModalProps> = ({ show, handleClose, categoryId, items, setItems, setData, originalItems, setOriginalItems, allItems, updateCategoryItems }) => {
  const [itemName, setItemName] = useState('');
  const [label, setLabel] = useState('');
  const [isDelivery, setIsDelivery] = useState(true);
  const [price, setPrice] = useState('');
  const [price_delivery, setPriceDelivery] = useState('');
  const [isOnline, setIsOnline] = useState(false);
  const [price_online, setPriceOnline] = useState('');
  const [isDesk, setIsDesk] = useState(true);
  const [priceDesk, setPriceDesk] = useState('');
  const [isCombo, setIsCombo] = useState(false);
  const [isComboGroup, setIsComboGroup] = useState(false); // NEW: is_combo_group field
  const [isStock, setIsStock] = useState(false);
  const [currentStock, setCurrentStock] = useState('');
  const [minQuantity, setMinQuantity] = useState('');
  const [description, setDescription] = useState('');
  const [gluten, setGluten] = useState(false);
  const [vegano, setVegano] = useState(false);
  const [sodio, setSodio] = useState(false);
  const [lactosa, setLactosa] = useState(false);
  const [azucar, setAzucar] = useState(false);
  const [alcohol, setAlcohol] = useState(false);
  const [vegetariano, setVegetariano] = useState(false);
  const [picante, setPicante] = useState(false);
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [unidadesMedida, setUnidadesMedida] = useState<Option[]>([]);
  const [unidadMedidaId, setUnidadMedidaId] = useState(0);
  const [selectedUnidadName, setSelectedUnidadName] = useState('Seleccionar unidad');
  const [ingredientSelections, setIngredientSelections] = useState<IngredientSelection[]>([]);
  const [menuCategories, setMenuCategories] = useState<Option[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null | undefined>(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState('Seleccione una categoría');
  // Workstation override state
  const [workstationId, setWorkstationId] = useState<number | null>(null);
  // Tabs state
  const [activeTab, setActiveTab] = useState<'basic' | 'advanced' | 'additions'>('basic');
  const [showHelpModal, setShowHelpModal] = useState(false);
  // Storage units state
  const [storageUnits, setStorageUnits] = useState<any[]>([]);
  const [selectedStorageUnit, setSelectedStorageUnit] = useState<any>(null);
  // New: stock management mode: 'item' or 'ingredients'
  const [stockManagementMode, setStockManagementMode] = useState<'item' | 'ingredients' | null>(null);

  // Third-party provider pricing state
  const [thirdPartyProviders, setThirdPartyProviders] = useState<{ third_party_provider_id: number; name: string }[]>([]);
  const [thirdPartyPrices, setThirdPartyPrices] = useState<{ [providerId: number]: string }>({});
  
  // Additions state for selection groups and modifiers
  const [additions, setAdditions] = useState<any>({
    selection_groups: [],
    modifiers: []
  });

  // Granel (by weight/volume) state
  const [isGranel, setIsGranel] = useState(false);
  const [selectedUnidadMedidaId, setSelectedUnidadMedidaId] = useState(0);
  const [selectedUnidadMedidaName, setSelectedUnidadMedidaName] = useState('Seleccione unidad');

  const [loading, setLoading] = useState(false);
  // localId extracted from localStorage (string in types) -> convert to number
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? parseInt(JSON.parse(userContext).local_id, 10) : 0;
  // Validation state for stock configuration
  const [stockConfigValid, setStockConfigValid] = useState(true);

  const mappedMenuCategories = React.useMemo(() => {
    return menuCategories.map(cat => ({
      id: cat.id,
      name: cat.name,
      subcategories: [],
      items: []
    }));
  }, [menuCategories]);

  // Function to check if form has any user input
  const hasUnsavedChanges = useCallback((): boolean => {
    return !!(
      itemName.trim() ||
      label.trim() ||
      price.trim() ||
      price_delivery.trim() ||
      price_online.trim() ||
      priceDesk.trim() ||
      description.trim() ||
      currentStock.trim() ||
      minQuantity.trim() ||
      imageFiles.length > 0 ||
      ingredientSelections.length > 0 ||
      (selectedCategoryId && selectedCategoryId > 0 && selectedCategoryName !== 'Seleccione una categoría') ||
      unidadMedidaId > 0 ||
      selectedStorageUnit ||
      isDelivery ||
      isOnline ||
      !isDesk || // isDesk defaults to true, so false means user changed it
      isCombo ||
      isComboGroup || // NEW: include isComboGroup in unsaved changes check
      isStock ||
      gluten ||
      vegano ||
      sodio ||
      lactosa ||
      azucar ||
      alcohol ||
      vegetariano ||
      picante ||
      additions.selection_groups.length > 0 ||
      additions.modifiers.length > 0 ||
      activeTab !== 'basic' || // User navigated to other tabs
      isGranel ||
      selectedUnidadMedidaId > 0
    );
  }, [
    itemName, label, price, price_delivery, price_online, priceDesk, description,
    currentStock, minQuantity, imageFiles, ingredientSelections, selectedCategoryId,
    selectedCategoryName, unidadMedidaId, selectedStorageUnit, isDelivery, isOnline,
    isDesk, isCombo, isComboGroup, isStock, gluten, vegano, sodio, lactosa, azucar, alcohol,
    vegetariano, picante, additions, activeTab, isGranel, selectedUnidadMedidaId
  ]);

  // Function to reset all form state to defaults
  const resetFormState = useCallback(() => {
    setItemName('');
    setLabel('');
    setPrice('');
    setPriceDelivery('');
    setPriceOnline('');
    setPriceDesk('');
    setDescription('');
    setIsDelivery(true);
    setIsOnline(false);
    setIsDesk(true);
    setIsCombo(false);
    setIsComboGroup(false); // NEW: reset isComboGroup
    setIsStock(false);
    setCurrentStock('');
    setMinQuantity('');
    setGluten(false);
    setVegano(false);
    setSodio(false);
    setLactosa(false);
    setAzucar(false);
    setAlcohol(false);
    setVegetariano(false);
    setPicante(false);
    setImageFiles([]);
    setUnidadMedidaId(0);
    setSelectedUnidadName('Seleccionar unidad');
    setIngredientSelections([]);
    setSelectedStorageUnit(null);
    setStockManagementMode(null);
    setActiveTab('basic');
    setAdditions({
      selection_groups: [],
      modifiers: []
    });
    
    // Reset granel state
    setIsGranel(false);
    setSelectedUnidadMedidaId(0);
    setSelectedUnidadMedidaName('Seleccione unidad');
    
    // Only reset category if not in a specific category context
    if (!categoryId) {
      setSelectedCategoryId(null);
      setSelectedCategoryName('Seleccione una categoría');
    }
  // Reset workstation override
  setWorkstationId(null);
  // Reset third-party prices
  setThirdPartyPrices({});
  }, [categoryId]);

  // Fetch third-party providers list
  useEffect(() => {
    GetAllThirdPartyProviders()
      .then((response) => {
        if (response?.data) {
          setThirdPartyProviders(response.data);
        }
      })
      .catch((err) => {
        console.error('Error fetching third party providers:', err);
      });
  }, []);

  const handleThirdPartyPriceChange = (providerId: number, price: string) => {
    setThirdPartyPrices(prev => ({
      ...prev,
      [providerId]: price
    }));
  };

  // Safe close function with confirmation
  const handleSafeClose = () => {
    if (hasUnsavedChanges()) {
      const userConfirmed = window.confirm(
        'Tienes cambios sin guardar.\n\n¿Estás seguro de que quieres cerrar? Se perderán todos los datos ingresados.\n\nPresiona "Aceptar" para cerrar sin guardar, o "Cancelar" para continuar editando.'
      );
      
      if (!userConfirmed) {
        return; // Don't close if user cancels
      }
    }
    
    // Reset form and close
    resetFormState();
    handleClose();
  };

  // Force close function for successful submissions (no confirmation needed)
  const handleForceClose = () => {
    resetFormState();
    handleClose();
  };

  // Validation for required fields
  // Allow creating items without a price; if price is empty we'll send price: 0 in the payload
  const isFormValid = itemName.trim() !== '' && selectedCategoryId !== null && selectedCategoryId !== undefined && selectedCategoryId > 0;

  useEffect(() => {

    if (show) {
      setLoading(true);
      // Fetch all data concurrently using Promise.all
      const user = localStorage.getItem('user');
      const localId = user != null ? JSON.parse(user).local_id : 0;

      Promise.all([
        getUnidadesMedidaOptions(),
        getCategoryOptions(),
        getStorageUnitsByLocalId(localId),
      ])
        .then(([unidadesMedidaResponse,
          categoryOptionsResponse,
          storageUnitsResponse
        ]) => {
          
          for(let i = 0; i < storageUnitsResponse.data.length; i++) {
            if (storageUnitsResponse.data[i].is_default=== true) {
              setSelectedStorageUnit(storageUnitsResponse.data[i].storage_unit_id);
              break;
            }
          }
          if (unidadesMedidaResponse) {
            setUnidadesMedida(unidadesMedidaResponse);
          }
          if (categoryOptionsResponse) {
            setMenuCategories(categoryOptionsResponse);
            
            // Pre-select category if categoryId is provided
            if (categoryId) {
              const categoryIdNumber = Number(categoryId);
              const selectedCategory = categoryOptionsResponse.find(cat => cat.id === categoryIdNumber);

              if (selectedCategory) {
                setSelectedCategoryId(categoryIdNumber);
                setSelectedCategoryName(selectedCategory.name);
              }
            }
          }
          if (storageUnitsResponse) {
            setStorageUnits(storageUnitsResponse.data);
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        })
        .finally(() => setLoading(false));
    }
  }, [show, allItems, categoryId]);

  // Reset form when modal closes
  useEffect(() => {
    if (!show) {
      // Use our centralized reset function
      resetFormState();
    }
  }, [show, resetFormState]);

  // Protect against browser navigation when there are unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (show && hasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    if (show) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }
  }, [show, hasUnsavedChanges]);

  useEffect(() => {
    // Always inherit base price to sales channels
    setPriceOnline(price);
    setPriceDelivery(price);
    setPriceDesk(price);
  }, [price, setPriceOnline, setPriceDelivery, setPriceDesk]);

  const handleFormSubmit = async () => {
    // Validate that a category has been selected
    if (!selectedCategoryId) {
      toast.error('Selecciona una categoría para crear el ítem');
      return;
    }

    // Additional validation for stock management modes
    if (isStock) {
      if (stockManagementMode === null) {
        toast.error('Selecciona cómo deseas gestionar el stock');
        return;
      }
      if (stockManagementMode === 'item') {
        // For combo groups, we don't need stock validation as inventory is managed through individual products
        if (!isComboGroup) {
          // Mandatory fields for item-based stock (only for non-combo items)
          if (currentStock === '') {
            toast.error('Ingrese el stock actual del ítem');
            return;
          }
          if (!selectedUnidadName || selectedUnidadName === 'Seleccionar unidad') {
            toast.error('Seleccione una unidad de medida');
            return;
          }
          if (!selectedStorageUnit) {
            toast.error('Seleccione una unidad de almacenamiento');
            return;
          }
        }
      }
      if (stockManagementMode === 'ingredients' && ingredientSelections.length === 0) {
        toast.error('Seleccione al menos un ingrediente para gestionar el stock');
        return;
      }
    }

    setLoading(true);

    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;

    const imageFileData = await Promise.all(
      imageFiles.map(async (file) => {
        const base64 = await fileToBase64(file);
        return { name: file.name, data: base64.split(',')[1] };
      })
    );

  // ⚠️ IMPORTANTE - NOMENCLATURA CRÍTICA ⚠️
  // NO CONFUNDIR ESTOS CAMPOS - SON EXACTAMENTE AL REVÉS DE LO QUE PARECEN:
  // 
  // - label (en BD)     = Nombre EN CARTA (bonito, con tildes)    Ej: "Pizza Margarita"
  // - item_name (en BD) = Nombre INTERNO (normalizado, sin tildes) Ej: "pizza_margarita"
  //
  // En el estado local del componente:
  // - itemName (state) = contiene el nombre normalizado -> va a item_name (BD)
  // - label (state)    = contiene el nombre en carta    -> va a label (BD)
  //
  // Por lo tanto el payload debe ser:
  let formData = {
      label: label.trim(),              // ← Nombre en carta (bonito) va al campo "label" de BD
      item_name: itemName.trim(),       // ← Nombre interno (normalizado) va al campo "item_name" de BD
      price: price === '' ? 0 : Number(price),
      is_delivery: isDelivery,
      price_delivery: price_delivery === '' ? null : Number(price_delivery),
      is_online: isOnline,
      price_online: price_online === '' ? null : Number(price_online),
      is_desk: isDesk,
      price_desk: priceDesk === '' ? null : Number(priceDesk),
      description: description,
      isCombo: isCombo,
      is_combo_group: isComboGroup, // NEW: include is_combo_group field
      state: true,
      gluten: gluten,
      vegano: vegano,
      sodio: sodio,
      lactosa: lactosa,
      azucar: azucar,
      alcohol: alcohol,
      vegetariano: vegetariano,
      picante: picante,
      category_id: selectedCategoryId,
      category_name: selectedCategoryName,
      local_id: localId,
      unidad_medida_id: isGranel ? selectedUnidadMedidaId : unidadMedidaId,
      units: 1, // Always set to 1
      provider_id: null,
      stock_control: isStock,
      current_stock: currentStock === '' ? 0 : Number(currentStock),
      min_quantity: minQuantity === '' ? 0 : Number(minQuantity),
      storage_unit_id: selectedStorageUnit,
      image_files: imageFileData,
      ingredient_selections: (isStock && stockManagementMode === 'item') ? [] : ingredientSelections,
      ingredients: ((isStock && stockManagementMode === 'item') ? [] : ingredientSelections).map(ingredient => ingredient.name),
      // NEW: Additions payload for selection groups and modifiers
      selection_groups: additions.selection_groups,
      modifiers: additions.modifiers,
      // Granel (by weight/volume) fields
  is_granel: isGranel,
  // Workstation override; when null, backend should use category default
  workstation_id: workstationId
    };
    
    createItem(formData).then(async (response) => {
      if (response) {
        toast.success('Item creado exitosamente');
        // Inicializar ingredientes y tiene_ingredientes si no existen
        const updatedItem: Item = {
          ...(response as any).data,
          ingredients: (response as any).data.ingredients ?? [],
          tiene_ingredientes: Array.isArray((response as any).data.ingredients) ? (response as any).data.ingredients.length > 0 : false
        };
        const newOriginalItems = [...originalItems, updatedItem].sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        setOriginalItems(newOriginalItems);
        setItems(newOriginalItems);
        setData(newOriginalItems);
        // --- ACTUALIZAR LA CATEGORÍA SI updateCategoryItems ESTÁ DISPONIBLE ---
        if (updateCategoryItems && selectedCategoryId) {
          // Buscar la categoría actual y agregar el nuevo ítem
          const updatedCategory: MenuCategoryNode = {
            id: Number(selectedCategoryId),
            name: selectedCategoryName,
            subcategories: [], // No se actualizan aquí
            items: [...(items || []), updatedItem],
          };
          updateCategoryItems(updatedCategory);
        }

        // Save third-party provider specific prices
        const newItemId = (response as any).data?.item_id || (response as any).data?.id;
        if (newItemId) {
          const tppPromises = Object.entries(thirdPartyPrices)
            .filter(([_, price]) => price && parseFloat(price) > 0)
            .map(([providerId, price]) => 
              setItemThirdPartyPrice(newItemId, parseInt(providerId), parseFloat(price))
                .catch(err => console.error(`Error setting TPP price for provider ${providerId}:`, err))
            );
          if (tppPromises.length > 0) {
            await Promise.all(tppPromises);
          }
        }

        // Reset form state after successful creation and close without confirmation
        handleForceClose();
      }
    }).catch((error) => {
      console.error(error);
      toast.error(error.response.data.message);
    }).finally(() => setLoading(false));
  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };


  return (
    <Modal 
      show={show} 
      onHide={handleSafeClose} 
      centered 
      className='create-item-modal-container'
      backdrop="static" // Prevent closing by clicking outside
      keyboard={false}  // Prevent closing with escape key
      enforceFocus={false} // Allow focus outside modal (for SearchDropdown portal)
    >

      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>
            Crear ítem
            <Button 
              variant="none" 
              className='help-button-badge'
              onClick={() => setShowHelpModal(true)}
              title="Ayuda para crear ítems"
            >
              <QuestionCircle size={20} />
            </Button>
          </Modal.Title>
        </div>
        <Button variant="none" className='modal-close-button' onClick={handleSafeClose}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {loading && <MiniLoadingSpinner left='50%' />}
        {!loading && 
        <Form>

          <FormNavigation
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />

          {activeTab === 'basic' && (
            <BasicInfoSection
              items={allItems}
              itemName={itemName}
              setItemName={setItemName}
              label={label}
              setLabel={setLabel}
              price={price}
              setPrice={setPrice}
              description={description}
              setDescription={setDescription}
              menuCategories={mappedMenuCategories}
              selectedCategoryId={selectedCategoryId}
              setSelectedCategoryId={setSelectedCategoryId}
              setSelectedCategoryName={setSelectedCategoryName}
              isDelivery={isDelivery}
              setIsDelivery={setIsDelivery}
              isOnline={isOnline}
              setIsOnline={setIsOnline}
              isDesk={isDesk}
              setIsDesk={setIsDesk}
              price_delivery={price_delivery}
              setPriceDelivery={setPriceDelivery}
              priceDesk={priceDesk}
              setPriceDesk={setPriceDesk}
              price_online={price_online}
              setPriceOnline={setPriceOnline}
              imageFiles={imageFiles}
              setImageFiles={setImageFiles}
              isGranel={isGranel}
              setIsGranel={setIsGranel}
              unidadesMedida={unidadesMedida}
              selectedUnidadMedidaId={selectedUnidadMedidaId}
              setSelectedUnidadMedidaId={setSelectedUnidadMedidaId}
              selectedUnidadMedidaName={selectedUnidadMedidaName}
              setSelectedUnidadMedidaName={setSelectedUnidadMedidaName}
              workstationId={workstationId}
              setWorkstationId={setWorkstationId}
              thirdPartyProviders={thirdPartyProviders}
              thirdPartyPrices={thirdPartyPrices}
              onThirdPartyPriceChange={handleThirdPartyPriceChange}
            />
          )}

          {activeTab === 'advanced' && (
            <AdvanceInfoSection
              vegano={vegano}
              setVegano={setVegano}
              sodio={sodio}
              setSodio={setSodio}
              lactosa={lactosa}
              setLactosa={setLactosa}
              azucar={azucar}
              setAzucar={setAzucar}
              alcohol={alcohol}
              setAlcohol={setAlcohol}
              vegetariano={vegetariano}
              setVegetariano={setVegetariano}
              picante={picante}
              setPicante={setPicante}
              gluten={gluten}
              setGluten={setGluten}
              unidadesMedida={unidadesMedida}
              isStock={isStock}
              setIsStock={(val: boolean) => {
                setIsStock(val);
                if (val) {
                  setStockManagementMode((prev) => prev ?? 'item');
                } else {
                  setStockManagementMode(null);
                }
              }}
              currentStock={currentStock}
              setCurrentStock={setCurrentStock}
              minQuantity={minQuantity}
              setMinQuantity={setMinQuantity}
              setUnidadMedidaId={setUnidadMedidaId}
              selectedUnidadName={selectedUnidadName}
              setSelectedUnidadName={setSelectedUnidadName}
              ingredientSelections={ingredientSelections}
              setIngredientSelections={setIngredientSelections}
              selectedStorageUnit={selectedStorageUnit}
              setSelectedStorageUnit={setSelectedStorageUnit}
              storageUnits={storageUnits}
              stockManagementMode={stockManagementMode}
              setStockManagementMode={setStockManagementMode}
              isComboGroup={isComboGroup}
              setIsComboGroup={setIsComboGroup}
              unidadMedidaId={unidadMedidaId}
              localId={localId}
              onValidationChange={(isValid: boolean) => setStockConfigValid(isValid)}
            />
          )}

          {activeTab === 'additions' && (
            <AdditionsInfoSection
              itemName={itemName}
              additions={additions}
              onAdditionsChange={(newAdditions) => setAdditions(newAdditions)}
            />
          )}



        </Form>
        }
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button className="form-button-cancel" variant="none" onClick={handleSafeClose}>Cancelar</Button>
          <Button 
            className="form-button-create" 
            variant="none" 
            onClick={handleFormSubmit}
            disabled={!isFormValid || loading || (isStock && stockManagementMode === null) || (isStock && stockManagementMode === 'item' && !stockConfigValid)}
          >
            Crear
          </Button>
        </div>
      </Modal.Footer>

      <ItemHelpModal 
        show={showHelpModal}
        onHide={() => setShowHelpModal(false)}
      />
    </Modal>
  );
};

export default CreateItem;